import DOMPurify from 'dompurify'

const HtmlContent = ({ content, contentClass }) => {
  function createMarkup() {
    let innerHtml = ''
    if (content) {
      innerHtml = content
    }

    return { __html: DOMPurify.sanitize(innerHtml, { ADD_ATTR: ['target'] }) }
  }

  return (
    <div className={contentClass} dangerouslySetInnerHTML={createMarkup()} />
  )
}

export default HtmlContent
